// RefundModal.js
import React from 'react';
import './RefundModal.css';

const formatModalDate = (unixTimestamp) => {
  if (!unixTimestamp) return 'N/A';
  try {
    return new Date(unixTimestamp * 1000).toLocaleString('en-IN', {
      year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
  } catch (error) {
    return 'Invalid Date';
  }
};

const RefundModal = ({ details, onClose }) => {
  if (!details) {
    return null;
  }
  
  const displayStatus = (status) => {
    if (!status) return 'N/A';
    if (status.toLowerCase() === 'processed') return 'Refunded';
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  return (
    // Using the unique class names you requested
    <div className="refund-modal-overlay" onClick={onClose}>
      <div className="refund-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="refund-modal-header">
          <h2>Refund Details</h2>
          <button onClick={onClose} className="refund-modal-close-btn">×</button>
        </div>
        <div className="refund-modal-body">
          <div className="refund-detail-item">
            <span className="refund-detail-label">Refund ID:</span>
            <span className="refund-detail-value">{details.id || 'N/A'}</span>
          </div>
          <div className="refund-detail-item">
            <span className="refund-detail-label">Status:</span>
            <span className={`refund-detail-value refund-status--${details.status?.toLowerCase()}`}>
              {displayStatus(details.status)}
            </span>
          </div>
          <div className="refund-detail-item">
            <span className="refund-detail-label">Refund Amount:</span>
            <span className="refund-detail-value">₹{details.amount ? (details.amount / 100).toLocaleString('en-IN') : '0'}</span>
          </div>
          <div className="refund-detail-item">
            <span className="refund-detail-label">Original Payment ID:</span>
            <span className="refund-detail-value">{details.payment_id || 'N/A'}</span>
          </div>
          <div className="refund-detail-item">
            <span className="refund-detail-label">Processed At:</span>
            <span className="refund-detail-value">{formatModalDate(details.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundModal;